import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useContext } from 'react';
import { node, shape, string } from 'prop-types';
import useNavigationBar, { DEFAULT } from '../Hooks/index.js';

var _excluded = ["children"];

// Context
var Context = /*#__PURE__*/React.createContext(DEFAULT);
var useNavConfigContext = function useNavConfigContext() {
  var context = useContext(Context);
  return context;
};
var SideNavigationBarProvider = function SideNavigationBarProvider(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var value = useNavigationBar(rest);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
};
SideNavigationBarProvider.propTypes = {
  children: node.isRequired,
  accountDetails: shape({
    accountId: string.isRequired,
    accountType: string.isRequired
  }).isRequired,
  aosBaseUrl: string.isRequired,
  adfsToken: string.isRequired,
  app: string.isRequired
};

export { SideNavigationBarProvider, Context as default, useNavConfigContext };
